<template>
    <!-- Submitter Details Section -->
    <div v-if="!loggedPartner">
        <h2 class="text-lg md:text-2xl font-semibold mb-4">
            {{ translation('who_is_submitting', ' Who is submitting?') }}
           </h2>
        <!-- Name and Email Fields -->

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <!-- Name Field -->
            <text-field
                type="text"
                :label="translation('name', 'Name')"
                v-model="loginForm.submitter_name"
                name="submitter_name"
                :error="errors.submitter_name"
                :error-message="errors.submitter_name"
                :field-class="{
                    'bg-white text-gray-900': appearance.is('public_page_content_input_style', 'white'),
                    'bg-transparent': appearance.is('public_page_content_input_style', 'transparent'),
                    'transition-shadow block w-full rounded focus:ring-0 py-2.5 px-3.5 text-sm border-gray-300 focus:border-gray-400': true,
                }"
            ></text-field>
            <!-- Email Field -->
            <text-field
                type="email"
                :label="translation('email_address', 'Email address')"
                v-model="loginForm.submitter_email"
                name="submitter_email"
                :error="errors.submitter_email"
                :error-message="errors.submitter_email"
                :field-class="{
                    'bg-white text-gray-900': appearance.is('public_page_content_input_style', 'white'),
                    'bg-transparent': appearance.is('public_page_content_input_style', 'transparent'),
                    'transition-shadow block w-full rounded focus:ring-0 py-2.5 px-3.5 text-sm border-gray-300 focus:border-gray-400': true,
                }"
            ></text-field>
        </div>

        <div class="flex items-center justify-end mt-4">

            <div class="text-sm mr-4">{{ translation('already_have_account', 'Already have partner account?') }}</div>

            <modal :title="translation('login', 'Log in')" size="simple" ref="program_lead_login_modal"
                   field-class="text-gray-900">
                <template #toggle>
                    <btn size="small"
                         :type="appearance.isCustomColor('public_page_content_button_color') ? 'custom-content' : appearance.get('public_page_content_button_color', 'teal')">
                        {{ translation('login', 'Log in') }}
                    </btn>
                </template>
                <template #body>
                    <div class="space-y-4">

                        <div class="flex items-center bg-red-50 px-4 py-3 rounded text-red-500 text-sm gap-3 relative"
                             role="alert" v-if="errors.general_error">
                            <ul>
                                <li>{{ errors.general_error }}</li>
                            </ul>
                        </div>

                        <template v-if="loginConfig.otp_login">
                            <text-field
                                :label="translation('email_address', 'Email address')"
                                v-model="loginForm.email"
                                field-id="otp_email"
                                :error="errors.otp_email"
                                :error-message="errors.otp_email"
                                :field-class="{
                                    'bg-white text-gray-900': appearance.is('public_page_content_input_style', 'white'),
                                    'bg-transparent': appearance.is('public_page_content_input_style', 'transparent'),
                                    'transition-shadow block w-full rounded focus:ring-0 py-2.5 px-3.5 text-sm border-gray-300 focus:border-gray-400': true,
                                }"
                            ></text-field>

                            <text-field
                                v-if="loginForm.otp.step === 2"
                                type="text"
                                :label="translation('otp_password', 'One-time password')"
                                v-model="loginForm.otp_token"
                                field-id="otp_password"
                                :error="errors.otp_token"
                                :error-message="errors.otp_token"
                                :field-class="{
                                    'bg-white text-gray-900': appearance.is('public_page_content_input_style', 'white'),
                                    'bg-transparent': appearance.is('public_page_content_input_style', 'transparent'),
                                    'transition-shadow block w-full rounded focus:ring-0 py-2.5 px-3.5 text-sm border-gray-300 focus:border-gray-400': true,
                                }"
                            ></text-field>

                            <text-field
                                type="hidden"
                                v-model="loginForm.otp_identifier"
                            ></text-field>
                        </template>
                        <template v-if="!loginConfig.otp_login">
                            <text-field
                                :label="translation('email_address', 'Email address')"
                                v-model="loginForm.email"
                                field-id="email"
                                :error="errors.email"
                                :error-message="errors.email"
                                :field-class="{
                                    'bg-white text-gray-900': appearance.is('public_page_content_input_style', 'white'),
                                    'bg-transparent': appearance.is('public_page_content_input_style', 'transparent'),
                                    'transition-shadow block w-full rounded focus:ring-0 py-2.5 px-3.5 text-sm border-gray-300 focus:border-gray-400': true,
                                }"
                            ></text-field>

                            <text-field
                                type="password"
                                :label="translation('password', 'Password')"
                                v-model="loginForm.password"
                                field-id="password"
                                :error="errors.password"
                                :error-message="errors.password"
                                :field-class="{
                                    'bg-white text-gray-900': appearance.is('public_page_content_input_style', 'white'),
                                    'bg-transparent': appearance.is('public_page_content_input_style', 'transparent'),
                                    'transition-shadow block w-full rounded focus:ring-0 py-2.5 px-3.5 text-sm border-gray-300 focus:border-gray-400': true,
                                }"
                            ></text-field>
                        </template>
                    </div>
                    <btn
                        size="large"
                        class="w-full mt-8"
                        v-on:click="login"
                        :type="appearance.isCustomColor('public_page_content_button_color') ? 'custom-content' : appearance.get('public_page_content_button_color', 'teal')"
                        :loading="loading.login">
                        {{ translation('login', 'Log in') }}
                    </btn>

                    <div v-if="loginConfig.social_login.available">
                        <div class="flex flex-row items-center justify-center py-4">
                            <div class="w-full">
                                <hr class="border-gray-200 border-opacity-75">
                            </div>
                            <div class="bg-white px-4">
                                <span class="text-sm text-gray-600">or</span>
                            </div>
                            <div class="w-full">
                                <hr class="border-gray-200 border-opacity-75">
                            </div>
                        </div>

                        <social-auth-btn
                            v-if="loginConfig.social_login.available"
                            provider="google"
                            context="program_lead_login"
                            :submit-url="loginConfig.social_login.submit_url"
                            :text="loginConfig.social_login.texts.login_with_google"
                        ></social-auth-btn>
                    </div>
                </template>
            </modal>
        </div>
        <!-- Login Button -->
    </div>

    <div class="flex justify-between items-center space-x-4" v-else>
        <div class="text-sm">
            {{ translation('logged_in', 'You are logged in as') }} <span class="font-semibold">{{ loggedPartner.name }}</span>.
        </div>
        <div>
            <btn size="small" v-on:click="logout" :loading="loading.logout">{{ translation('log_out', 'Log out') }}</btn>
        </div>
    </div>

</template>

<script setup>

import {ref, computed} from 'vue';
import Modal from "../../../elements/Modal.vue";
import TextField from "../../../elements/forms/TextField.vue";
import SocialAuthBtn from "../../../components/partners/login/social/SocialAuthBtn.vue";
import appearance from "../../../helpers/appearanceConfig";

const props = defineProps({
    loggedPartner: {
        type: [Object, null],
        default: null,
    },
    loginConfig: {
        type: [Object],
        default: {
            otp_login: false,
            social_login: {
                available: false,
                submit_url: null,
                texts: {
                    login_with_google: 'Login with Google',
                }
            }
        },
        required: true
    },
    translations: {
        type: Object,
        default: {},
    }
});

const translations = props.translations ?? {};
const program_lead_login_modal = ref(null);
const loggedPartner = ref(props.loggedPartner);
const loginConfig = ref(props.loginConfig);
const loginForm = ref({
    email: null,
    password: null,
    submitter_name: null,
    submitter_email: null,
    otp_token: null,
    otp_identifier: null,
    otp: {
        step: 1
    }
});

const loading = ref({
    login: false,
    logout: false,
});

const errors = ref({
    otp_email: null,
    otp_token: null,
    submitter_name: null,
    submitter_email: null,
    general_error: null
});

const login = () => {

    if (loginConfig.value.otp_login) {
        return otpLogin();
    }

    return simpleLogin();
}

const logout = () => {
    if (loading.value.logout === true) {
        return;
    }

    loading.value.logout = true;

    axios.post(route('partners.leads.login.logout'))
        .then(response => {
            const status = parseInt(response.data.status ?? -1);
            if (status === 1) {

                loggedPartner.value = null;
            }
        }).finally(() => loading.value.logout = false);

    return true;
}

const simpleLogin = () => {

    if (loading.value.login === true) {
        return;
    }

    loading.value.login = true;
    errors.value.general_error = null;

    axios.post(route('partners.leads.login.login'), {
        email: loginForm.value.email,
        password: loginForm.value.password,
    }).then(response => {
        const status = parseInt(response.data.status ?? -1);
        if (status === 1) {

            program_lead_login_modal.value.onCancel();

            loginForm.value.email = null;
            loginForm.value.password = null;

            loggedPartner.value = response.data.logged_partner;
        } else {
            errors.value.general_error = 'Account not found or bad credentials';
        }
    }).finally(() => loading.value.login = false);

    return true;
}

const otpLogin = () => {

    if (loading.value.login === true) {
        return;
    }

    loading.value.login = true;
    errors.value.general_error = null;

    if (loginForm.value.otp.step === 1) {
        axios.post(route('partners.leads.login.otp_ini'), {
            email: loginForm.value.email,
        }).then(response => {
            const status = parseInt(response.data.status ?? -1);
            if (status === 1) {
                loginForm.value.otp_identifier = response.data.otp_identifier;
                loginForm.value.otp.step = 2;
            }

            if (status === 0) {
                errors.value.general_error = response.data?.error ?? 'Account not found or bad credentials';
            }
        }).finally(() => loading.value.login = false);
    }

    if (loginForm.value.otp.step === 2) {
        axios.post(route('partners.leads.login.login'), {
            otp_token: loginForm.value.otp_token,
            otp_identifier: loginForm.value.otp_identifier,
        }).then(response => {
            const status = parseInt(response.data.status ?? -1);
            if (status === 1) {

                program_lead_login_modal.value.onCancel();

                loginForm.value.otp.step = 1;
                loginForm.value.email = null;
                loginForm.value.otp_identifier = null;
                loginForm.value.otp_identifier = null;

                loggedPartner.value = response.data.logged_partner;
            } else {
                errors.value.general_error = 'Account not found or bad credentials';
            }
        }).finally(() => loading.value.login = false);
    }

    return true;
}

const translation = (name, defaultValue = '') => {
    if (translations.hasOwnProperty(name) && !translations[name] !== null) {
        return translations[name];
    }

    return defaultValue;
}

</script>

<style scoped>

</style>
